import { AxiosRequestConfig } from 'axios';
import { currentLanguage } from 'shared/constants/common';
import { findCookieValue } from 'shared/util/utility';

const MyBetApiWrapper = (requests: any) => {
	return {
		MakeBet: (body: { description: string }) => {
			const config: AxiosRequestConfig = {
				headers: {
					'Request-Language': currentLanguage,
					'x-odds-session': findCookieValue('x-odds-session'),
				},
			};
			return requests.post('/cms/my-bet', body, config);
		},
	};
};

export default MyBetApiWrapper;
